import { DashboardMenu, DashboardMenuOption } from 'components/dashboard-menu/component'
import { GenericNavigatorSelectedItemProps } from 'components/generic-navigator/component'
import { DesktopNavigator } from 'components/generic-navigator/desktop'
import { Loading } from 'components/loading'
import { RasaContext } from 'context'
import React, {Component} from 'react'
import { SharedKeys, SharedStore } from 'shared/data-layer/sharedStore'
import { PersonInfo } from 'user'
import * as Flash from '../../components/flash'
import { getValueWithRetry } from '../../generic/utility'
import { PanelBarOption } from '../../components/panel-bar/types'
import { allSections } from './constants'
import { BLASTS_FEATURE_NAME } from './blasts-constants'

interface BlastsComponentState {
  activeCommunity: any,
  isLoading: boolean,
  person: PersonInfo,
  role: any,
  sections: PanelBarOption[],
}

export class BlastsComponent extends Component<GenericNavigatorSelectedItemProps, BlastsComponentState> {
  public static contextType = RasaContext
  private sharedStore: SharedStore

  constructor(props: GenericNavigatorSelectedItemProps) {
    super(props)
    this.state = {
      activeCommunity: null,
      isLoading: true,
      person: null,
      role: null,
      sections: [],
    }
  }

  public componentDidMount = () => {
    this.sharedStore = SharedStore.instance(this.context)
    getValueWithRetry(this.sharedStore, SharedKeys.activeCommunity).then((activeCommunity) => {
      Promise.all([
        this.sharedStore.getValue(SharedKeys.person),
        this.sharedStore.getValue(SharedKeys.role),
      ]).then(([person, role]) => {
        this.setState({
          activeCommunity,
          isLoading: false,
          person,
          role,
          sections: allSections,
        })
      })
    }).catch((error) => {
      this.setState({
        isLoading: false,
      }, () => {
        this.context.store.dispatch(Flash.showFlashError(error))
      })
    })
  }

  public render() {
    return (
      this.state.isLoading ? <Loading size="64" /> :
      <div>
        <DashboardMenu selected={DashboardMenuOption.blasts} />
        <div>
          <DesktopNavigator
            selectedItem={this.props.selectedItem}
            sections={this.state.sections}
            baseRoute={DashboardMenuOption.blasts}
            title={BLASTS_FEATURE_NAME}
            subTitle="Manage your blast campaigns"
          />
        </div>
      </div>
    );
  }
}
